import { Component } from '@angular/core';
import { IWizItemRenderer, WizBaseCollector } from '@wizeoo/akm-component-lib';
import { LanguageVO } from '../../../vo/locale/language.vo';

/**
 * rendu d'un avec une checkbox, une image et un label
 */
@Component({
  selector: 'language-renderer',
  templateUrl: './language.renderer.html',
})
export class LanguageRenderer implements IWizItemRenderer<null, LanguageVO> {
  data: LanguageVO;
  owner: WizBaseCollector;
}
